







import { bus } from "@/bus";
import { fixedHtmlData } from "@/services/posts/postTypes/fixedhtml";
import { Component, Prop, Vue } from "vue-property-decorator";
import { saveSelection, restoreSelection } from "@/services/posts/postsService";

@Component
export default class TextComponentForm extends Vue {
    @Prop() vsid!: string;

    timeout = 0;
    isOverflowing = false;
    prevState = "";
    prevCarat = {
        start: 0,
        end: 0
    };

    get properties(): fixedHtmlData {
        return ((this.$parent as any).localProperties.data).filter((x: fixedHtmlData) => x.id === this.vsid)[0];
    }

    get preventOverflow() {
        return this.properties.preventOverflow === "true";
    }

    mounted() {
        bus.$on("getComponentData", () => {
            if (this.$refs.text) {
                const text = (this.$refs.text as HTMLElement).innerHTML;
                this.properties.text = text;
            }
        });

        if (this.preventOverflow) {
            const textRef = (this.$refs.text as any);
            this.prevState = textRef.innerHTML;
        }
    }

    destroyed() {
        bus.$off("getComponentData");
    }

    handleInput(e: any) {
        if (!this.preventOverflow) return;

        this.isOverflowing = (e.target.scrollHeight > e.target.clientHeight) || (e.target.scrollWidth > e.target.offsetWidth);
        if (this.isOverflowing) {
            // If we're overflowing, restore the state to previous state and also restore the carat position.
            e.target.innerHTML = this.prevState;
            restoreSelection(e.target, this.prevCarat);

            // Turning the overflow off after 150ms means we get a quick red-flash on the border to indicate the action the user did caused overflow.
            clearTimeout(this.timeout);
            this.timeout = setTimeout(() => {
                this.isOverflowing = false;
            }, 150);
            return;
        }
        this.prevState = e.target.innerHTML;
    }

    saveCaratPosition(e: any) {
        if (this.preventOverflow) this.prevCarat = saveSelection(e.currentTarget);
    }

    paste(e: any) {
        if (document.queryCommandSupported("insertHTML")) { // Make sure we don't accidently break pasting if browsers ever remove this already deprecated feature
            e.preventDefault();
            var toPlainText = (e.originalEvent || e).clipboardData.getData("text/plain");
            document.execCommand("insertHTML", false, toPlainText);
        }
    }
}
